/* eslint-disable react/prop-types */ // TODO: add props
import PT from 'prop-types';
import { useCallback } from 'react';
import classNames from 'classnames';
import urlResolver from 'edrolo/utils/URLResolver';

export const PrintExamLink = ({ examId, origin, className, children }) => {
  const memoizedHandleClick = useCallback(() => {
    analytics.track('clicked print exam link', {
      exam_id: examId,
      origin: origin,
    });
  }, [examId, origin]);

  const classes = classNames('print-exam', className);
  const url = urlResolver.reverse('exams-print', {
    examId,
  });

  return (
    <a
      id="print-exam"
      className={classes}
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={memoizedHandleClick}
    >
      {children || 'Print exam'}
    </a>
  );
};

PrintExamLink.propTypes = {
  examId: PT.number,
  origin: PT.string,
  children: PT.node,
};
